import { Link } from "@tanstack/react-router";
import logoDark from "@/assets/logo-dark.svg";
import logoLight from "@/assets/logo-light.svg";
import logoIcon from "@/assets/logo-icon.svg";
import { useAppearance } from "@/components/appearance-provider";

export function Logo({
  className = "",
  variant = "auto",
  iconOnly = false,
}: {
  className?: string;
  variant?: "auto" | "dark" | "light";
  iconOnly?: boolean;
}) {
  const { appearance } = useAppearance();
  const darkSrc = appearance.logo_dark_url || logoDark;   // for light bg
  const lightSrc = appearance.logo_light_url || logoLight; // for dark bg
  const iconSrc = appearance.logo_icon_url || logoIcon;

  if (iconOnly) {
    return (
      <Link to="/" className={`inline-flex items-center ${className}`} aria-label="CoderLity Home">
        <img
          src={iconSrc}
          alt="CoderLity Logo"
          width={32}
          height={32}
          decoding="async"
          className="h-8 w-8"
        />
      </Link>
    );
  }

  return (
    <Link to="/" className={`inline-flex items-center ${className}`} aria-label="CoderLity Home">
      {variant === "auto" ? (
        <>
          <img
            src={darkSrc}
            alt="CoderLity Logo"
            width={153}
            height={32}
            decoding="async"
            className="block dark:hidden h-8 w-auto"
          />
          <img
            src={lightSrc}
            alt="CoderLity Logo"
            width={153}
            height={32}
            decoding="async"
            className="hidden dark:block h-8 w-auto"
          />
        </>
      ) : variant === "light" ? (
        <img
          src={lightSrc}
          alt="CoderLity Logo"
          width={153}
          height={32}
          decoding="async"
          className="h-8 w-auto"
        />
      ) : (
        <img
          src={darkSrc}
          alt="CoderLity Logo"
          width={153}
          height={32}
          decoding="async"
          className="h-8 w-auto"
        />
      )}
    </Link>
  );
}
